import {
  RETURN_DEVUELTA_FILTER,
  RETURN_NO_DEVUELTA_FILTER,
  RETURN_NO_REINGRESADA_A_STOCK_FILTER,
  RETURN_PROCESADA_FILTER,
  RETURN_REINGRESADA_A_STOCK_FILTER,
} from "../../../../assets/constants/exchangeConsts/orderExchangeStatus";

export const MAX_PACKAGE_QUANTITY = 25;

export const ORDERS_QUERY_KEYS = {
  all: ["order"],
  fetch: (filters) => [...ORDERS_QUERY_KEYS.all, "order_fetch", filters],
  fetchItems: (filters) => [...ORDERS_QUERY_KEYS.all, "items", filters],
  search: (filters) => [...ORDERS_QUERY_KEYS.all, filters],
  shippingOptions: (filters) => [
    ...ORDERS_QUERY_KEYS.all,
    "shipping_option",
    filters,
  ],
};

//? creation
export const BUYER_FIELDS = [
  "doc_number",
  "doc_type",
  "email",
  "full_name",
  "last_name",
  "name",
  "phone",
];

//? statuses
export const NEW = "new";
export const RESCHEDILING_VISIT = "rescheduling_visit";
export const VISIT_SCHEDULED = "visit_scheduled";
export const VISIT_SHIPPING = "visit_shipping";
export const VISIT_DISPATCHED = "visit_dispatched";
export const DISPATCHED = "dispatched";
export const NOT_DELIVERED = "not_delivered";
export const CANCELLED = "cancelled";
export const DELIVERED = "delivered";
export const VISIT_FALIED = "visit_failed";
export const PROCESSED = "check_in_processed";
export const TO_DISPATCH = "processing";
export const TO_RETURN = "check_in_visit_scheduled";
export const RETURNED = "check_in_completed";
export const SHIPPED = "shipped";
export const CHECK_IN_SHIPPED = "check_in_shipped";
export const READY_TO_PICK = "ready_to_pick";
export const ON_HOLD = "on_hold";
export const READY_TO_SHIP = "ready_to_ship";
export const AWAITING_PAYMENT = "awaiting_payment";
export const PACKING_SLIP = "packing_slip";
export const PICKED = "picked";
export const RECEIVED = "received";

export const IN_POST_OFFICE = "in_post_office";
export const ORDER_PROCESSED = "processed";
export const ORDER_RETURNED = "completed";

export const STATUSES_ICONS = {
  awaiting_payment: {
    icon: "awaitingPayment",
  },
  cancelled: {
    icon: "cancelled",
  },
  delivered: {
    icon: "delivered",
  },
  new: {
    icon: "new",
  },
  not_delivered: {
    icon: "notDelivered",
    transform: "down-1",
  },
  on_hold: {
    icon: "pause",
  },
  packing_slip: {
    icon: "box",
  },
  picking_list: {
    icon: "box",
  },
  ready_to_pick: {
    icon: "boxOpen",
  },
  ready_to_ship: {
    icon: "loading",
  },
  shipped: {
    icon: "shipped",
  },
  // --- PSEUDO STATES --------------------------
  pickup_requested: {
    icon: "pickupRequested",
  },
  returned: {
    icon: "undo",
  },
};

export const ORDER_STATUSES = [
  {
    key: "Esperando pago",
    value: "awaiting_payment",
  },
  {
    key: "Nuevo",
    value: "new",
  },
  {
    key: "Listo para preparar",
    value: "ready_to_pick",
  },
  {
    key: "En recolección",
    value: "pickup_requested",
  },
  {
    key: "En preparación",
    value: "picking_list",
  },
  {
    key: "Empaquetando",
    value: "packing_slip",
  },
  {
    key: "Listo para despachar",
    value: "ready_to_ship",
  },
  {
    key: "Despachado",
    value: "shipped",
  },
  {
    key: "Detenido",
    value: "on_hold",
  },
  {
    key: "Cancelado",
    value: "cancelled",
  },
  {
    key: "Entregado",
    value: "delivered",
  },
  {
    key: "No entregado",
    value: "not_delivered",
  },
  {
    key: "Procesado",
    value: RETURN_PROCESADA_FILTER,
  },
  {
    key: "Devuelto",
    value: RETURN_DEVUELTA_FILTER,
  },
  {
    key: "No devuelto",
    value: RETURN_NO_DEVUELTA_FILTER,
  },
  {
    key: "Reingresado a stock",
    value: RETURN_REINGRESADA_A_STOCK_FILTER,
  },
  {
    key: "No reingresado a stock",
    value: RETURN_NO_REINGRESADA_A_STOCK_FILTER,
  },
];

export const STATUSES_TEXT = {
  new: "Nuevo",
  awaiting_payment: "Esperando pago",
  ready_to_pick: "A preparar",
  picking_list: "Preparando",
  packing_slip: "Preparando",
  ready_to_ship: "A despachar",
  shipped: "Despachado",
  delivered: "Entregado",
  cancelled: "Cancelado",
  not_delivered: "No entregado",
  on_hold: "Detenido",
  // --- PSEUDO STATES --------------------------
  pickup_requested: "A recolectar",
};

export const STATUSES_COLOR = {
  awaiting_payment: "warning",
  cancelled: "error",
  delivered: "success",
  new: "warning",
  not_delivered: "error",
  on_hold: "error",
  packing_slip: "grey",
  picking_list: "grey",
  ready_to_pick: "grey",
  ready_to_ship: "grey",
  shipped: "highlight",
  // --- PSEUDO STATES --------------------------
  pickup_requested: "warning",
  returned: "success",
};

export const SHIPMENT_FIELDS_TO_COMPARE = [
  "shipping_option.service_code",
  "shipping_option.service_type",
  "ship_from_warehouse_id",
  "ship_to_warehouse_id",
  "buyerInfo.country.code",
  "buyerInfo.warehouse_id",
  "buyerInfo.post_office_id",
  "buyerInfo.street_name",
  "buyerInfo.street_number",
  "buyerInfo.zip_code",
  "buyerInfo.state",
  "buyerInfo.city",
];

export const SHIPMENT_PARAMS_SENT_TO_BACK = [
  "delivery_for",
  "ship_from",
  "ship_from_warehouse_id",
  "ship_to_warehouse_id",
  "ship_to",
  "shipping_option",
];

export const ORDER_WARNING_LABELS = {
  without_stock: "Sin stock",
  service_pending: "Sin servicio",
  from_zip_code_non_existent: "Código postal inválido",
  to_zip_code_non_existent: "Código postal inválido",
  drop_off_invalid: "Sucursal inválida",
  pickup_point_invalid: "Sucursal inválida",
};
